import React from "react";
import { Toaster } from "sonner";
import Hero from "../components/gridvest/Hero";
import WhoWeServe from "../components/gridvest/WhoWeServe";
import WhatWeDo from "../components/gridvest/WhatWeDo";
import Founders from "../components/gridvest/Founders";
import Waitlist from "../components/gridvest/Waitlist";
import Footer from "../components/gridvest/Footer";

/**
 * /overview — the original multi-section "Coming Soon" layout preserved here
 * (not linked from the public landing page). Reachable by direct URL only.
 */
export default function OverviewPage() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="min-h-screen bg-[#07111F] text-[#F8FAFC]" data-testid="overview-page">
      <Hero
        onJoinWaitlist={() => scrollTo("early")}
        onOwnerClick={() => scrollTo("who-we-serve")}
        onMunicipalClick={() => scrollTo("who-we-serve")}
      />
      <WhoWeServe />
      <WhatWeDo />
      <Founders />
      <Waitlist />
      <Footer />
      <Toaster theme="dark" position="top-right" richColors closeButton />
    </div>
  );
}
